<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getTourCategoryTitle"]),
  },
};
</script>

<template>
    <div class="container px-md--0">
        <div class="c-main-loading">
            <div class="main-loading">
                <img class="main-loading__img" alt="profile"
                     src="/Themes/SoofiGashtV2/UI/Dist/images/flight-loading.jpg" />

                <div class="main-loading__content">
                    <span class="main-loading__subtitle">در حال یافتن بهترین تورها برای شما هستیم</span>

                    <span class="main-loading__title">{{ getTourCategoryTitle }}</span>

                    <span class="main-loading__description">کمی صبر کنید</span>

                    <div class="main-loading__progress">
                        <div class="main-loading__progress-filler"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
